import React from "react";
// css comes in hw_master.css

const ThreeDot = ({ setQuestion, questionIndex }) => {
  const removeQuestion = () => {
    setQuestion((prev) => {
      const newQuestion = prev.filter((_, i) => i !== questionIndex);
      return newQuestion;
    });
  };
  return (
    <>
      <div className=" p-3 main_card_popup_box ">
        <button className="main_card_popup_button" onClick={removeQuestion}>
          Delete
        </button>
      </div>
    </>
  );
};

export default ThreeDot;
